export const GROUP_UPDATED = 'GROUP_UPDATED';
export const updateGroup = conditions => ({
  type: GROUP_UPDATED,
  payload: conditions,
});

export const CLAUSE_ADDED = 'CLAUSE_ADDED';
export const addClause = () => ({
  type: CLAUSE_ADDED,
});

export const CLAUSE_UPDATED = 'CLAUSE_UPDATED';
export const updateClause = (index, changes) => ({
  type: CLAUSE_UPDATED,
  payload: { index, changes },
});

export const CLAUSE_NEGATED = 'CLAUSE_NEGATED';
export const negateClause = index => ({
  type: CLAUSE_NEGATED,
  payload: { index },
});

export const CLAUSE_PERMITTED = 'CLAUSE_PERMITTED';
export const permitClause = index => ({
  type: CLAUSE_PERMITTED,
  payload: { index },
});

export const CLAUSE_DELETED = 'CLAUSE_DELETED';
export const deleteClause = index => ({
  type: CLAUSE_DELETED,
  payload: { index },
});

export const GROUP_CLAUSE_ADDED = 'GROUP_CLAUSE_ADDED';
export const addGroup = () => ({
  type: GROUP_CLAUSE_ADDED,
});

export const GROUP_UNGROUPED = 'GROUP_UNGROUPED';
export const ungroup = () => ({
  type: GROUP_UNGROUPED,
});

export const GROUP_DELETED = 'GROUP_DELETED';
export const deleteGroup = () => ({
  type: GROUP_DELETED,
});
